import { useEffect, useRef, useState } from "react";
import {
  Button,
  Dropdown,
  DropdownBody,
  DropdownButton,
  DropdownItem,
} from "@components";
import { LayoutThreeColumns, ThreeDots } from "react-bootstrap-icons";
import { cn } from "@utils";
import { ManageColumnsList } from "./ManageColumnsButton";

export const TableMenu = ({ children, columnsManager }) => {
  const [columnsOpen, setColumnsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!columnsOpen) return;
    const handler = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setColumnsOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [columnsOpen]);

  return (
    <div ref={containerRef} className="relative">
      <Dropdown>
        <DropdownButton>
          <Button
            color="secondary"
            aria-label="More actions"
            title="More actions"
            className="h-8"
            onClick={() => setColumnsOpen(false)}
          >
            <ThreeDots />
          </Button>
        </DropdownButton>
        <DropdownBody position="left" className="min-w-56 w-max">
          {children}
          {columnsManager && (
            <TableMenuItem
              icon={LayoutThreeColumns}
              onClick={() => setColumnsOpen(true)}
            >
              Edit columns
            </TableMenuItem>
          )}
        </DropdownBody>
      </Dropdown>
      {columnsManager && columnsOpen && (
        <div className="absolute z-30 right-0 top-full mt-2 w-56 rounded-md bg-white shadow-lg ring-1 ring-black/5 p-1 overflow-y-auto">
          <ManageColumnsList
            data={columnsManager.data}
            setData={columnsManager.setData}
            onReset={columnsManager.onReset}
          />
        </div>
      )}
    </div>
  );
};

export const TableMenuItem = ({
  onClick,
  disabled,
  icon: Icon,
  subtext,
  children,
}) => (
  <DropdownItem
    closeOnComplete
    onClick={onClick}
    disabled={disabled}
    className={cn(disabled && "text-zinc-400 hover:text-none")}
  >
    {Icon && <Icon className="me-2 size-3.5 shrink-0" />}
    <span className="whitespace-nowrap font-medium">{children}</span>
    {subtext && (
      <span className="ml-2 text-xs text-zinc-500 whitespace-nowrap">
        {subtext}
      </span>
    )}
  </DropdownItem>
);
